var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ion-list',[_vm._l((_vm.children),function(child,index){return _c('ion-item',{key:index,attrs:{"button":""},on:{"click":ev => _vm.onClick(ev, child)}},[_vm._v(" "+_vm._s(_vm.menuLabel(child))+" ")])}),_c('ion-item',{attrs:{"lines":"none","detail":"false","button":""},on:{"click":_vm.dismiss}},[_vm._v(" Close ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }